import { render } from "./Aboutus.vue?vue&type=template&id=cd40127a&scoped=true"
import script from "./Aboutus.vue?vue&type=script&lang=js"
export * from "./Aboutus.vue?vue&type=script&lang=js"

import "./Aboutus.vue?vue&type=style&index=0&id=cd40127a&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd40127a"]])

export default __exports__